// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__b6210791ef656af485b3","cls2":"SimplePaperPodcast-cls2___33b93e7632f92f79463 SimplePaperPodcast-cls1__b6210791ef656af485b3"};